import styled from "styled-components";

export const AppLogo = styled.img`
  width: 200px;
  margin: auto;
  display: block;
  transform: translateY(3em);
  
`;
